import { render, staticRenderFns } from "./receipt_table.vue?vue&type=template&id=4f465c30&scoped=true"
import script from "./receipt_table.vue?vue&type=script&lang=js"
export * from "./receipt_table.vue?vue&type=script&lang=js"
import style0 from "./receipt_table.vue?vue&type=style&index=0&id=4f465c30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f465c30",
  null
  
)

export default component.exports